export default {"src":"/_next/static/media/digital-experience-icon.1b0d49b1.svg","height":138,"width":138,"blurWidth":0,"blurHeight":0};